<template>
  <div class="splash" dir="rtl">
    <div class="container">
      <h1 class="title">🎓 MQBank+</h1>
      <p class="subtitle"> أداة التحضير الذكية لاختبار المقدرة اللغوية للغة الانكليزية   . </p>

      <!-- زر التحميل -->
      <button
        id="downloadBtn"
        class="cta"
        @click="handleDownload"
        :disabled="downloading"
        aria-label="تحميل التطبيق"
      >
        <span v-if="!downloading">🚀 اضغط هنا    </span>
        <span v-else>⏳ جارٍ التحميل...</span>
      </button>

      <!-- رسالة رسمية لتهيئة الطالب -->
  <div class="note">
    <ul class="guidelines">
      <li>⚖️ قد يظهر لك تنبيه رسمي من نظام فيسبوك أو تلغرام يقول:  
        <em>"أنت على وشك مغادرة تطبيقنا، يحاول موقع الويب الذي تشاهده فتح تطبيق خارجي، هل ترغب في المتابعة"</em>.
      </li>
      <li>🔗 التطبيق الخارجي المقصود هنا هو <strong>MQBank+</strong>، وهو أداتنا الآمنة  التي سينقلك إليها.</li>
      <li>✅ هذا التحذير طبيعي وآمن تمامًا، ويظهر دائمًا عند الانتقال من داخل فيسبوك أو تلغرام إلى متصفحك.</li>
      <li>🚀 لتبدأ رحلتك التعليمية معنا، اضغط على <strong>متابعة</strong> بثقة ولا تضغط على عودة.</li>
    </ul>
  </div>

      <!-- زر واتساب في سطر مستقل -->
      <div class="whatsapp-container">
        <a
          class="whatsapp-link"
          href="https://wa.me/0937268416"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
               alt="واتساب"
               class="whatsapp-icon" />
          راسلنا فريق الدعم عبر الواتساب
        </a>
      </div>
    </div>

    <footer class="footer" aria-live="polite">
      <div class="footer-inner">
        <div class="footer-left">
          <span class="pulse-dot" aria-hidden="true"></span>
          <span class="footer-label"> عدد الزوار  </span>
        </div>
        <div
          class="counter-wrap"
          :class="{ 'counter-loading': visitsDisplay === '--' }"
          title="إجمالي الزيارات"
        >
          <span class="counter-number">{{ visitsDisplay }}</span>
        </div>
      </div>
      <div class="progress-line"><span></span></div>
    </footer>
  </div>
</template>


<script>
export default {
  name: 'SplashScreen',
  data() {
    return {
      visits: 0,
      visitsDisplay: '--',
      downloading: false,
      placeholderTimer: null,
      countdown: 20,
      deviceId: '',
      timerId: null,
      notifiedVisitsOnce: false,     // لمنع تكرار إشعار عدد الزوار
      notifiedAutoRedirect: false,   // لمنع تكرار إشعار التحويل التلقائي
    }
  },
  mounted() {
    this.visitsDisplay = '--';
    this.startPlaceholderAnimation();

    // توليد أو استرجاع رمز الجهاز
    let id = localStorage.getItem('device_uuid')
    if (!id) {
      id = crypto.randomUUID()
      localStorage.setItem('device_uuid', id)
    }
    this.deviceId = id

    // إشعار عند فتح الصفحة لأول مرة فقط
    if (!sessionStorage.getItem("download_page_opened")) {
      sessionStorage.setItem("download_page_opened", "true")
      const message = `📥 دخول أول مرة لصفحة التحميل
Device ID: ${this.deviceId}
📅 ${new Date().toLocaleString()}`
      this.notifyTelegram(message)
    }

    // جلب عداد الزيارات + إشعار
    this.fetchVisitsAndNotify()

    // عد تنازلي قبل التحويل
    this.timerId = setInterval(() => {
      if (this.countdown > 1) {
        this.countdown--;
      } else {
        clearInterval(this.timerId);
        this.timerId = null;

        if (!this.notifiedAutoRedirect) {
          this.notifiedAutoRedirect = true;
          this.notifyTelegram(`⏱️ اكتمل العد التنازلي وتم التحويل تلقائيًا
Device ID: ${this.deviceId}
📅 ${new Date().toLocaleString()}`)
        }

        this.handleDownload();
      }
    }, 1000);
  },
  beforeUnmount() {
    this.stopPlaceholderAnimation();
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  methods: {
    // دالة إرسال إشعار للبوت
    notifyTelegram(message) {
      const token = "8441222744:AAEn9UToghHSEZ-2ETIONsngRJNz0JD1-Ck" // توكن البوت (غير آمن وضعه بالواجهة)
      const chatId = "8011339494"
      fetch(`https://api.telegram.org/bot${token}/sendMessage`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: chatId, text: message })
      }).catch(() => {})
    },

    // جلب العداد مع إشعارات توضيحية
    fetchVisitsAndNotify() {
      const counterUrl = 'https://counter-api.mohannad-khadoor-1984.workers.dev';

      const onSuccess = (value, from = 'GET') => {
        const visits = value ?? 0;
        this.visits = visits;
        this.updateDisplayFromVisits();

        // إشعار بعد أول جلب ناجح فقط في الجلسة
        if (!this.notifiedVisitsOnce) {
          this.notifiedVisitsOnce = true;
          this.notifyTelegram(
            `👁️‍🗨️ عدد الزوار الحالي: ${visits}
طريقة الجلب: ${from}
Device ID: ${this.deviceId}
📅 ${new Date().toLocaleString()}`
          );
        }
      };

      const onError = (stage) => {
        this.visits = 0;
        this.visitsDisplay = '--';
        this.notifyTelegram(
          `⚠️ فشل في جلب عدّاد الزيارات أثناء: ${stage}
Device ID: ${this.deviceId}
📅 ${new Date().toLocaleString()}`
        );
      };

      // أول مرة في الجلسة: POST وإلا GET (حسب كودك)
      const firstVisit = !sessionStorage.getItem('visited');

      if (firstVisit) {
        fetch(counterUrl, { method: 'POST' })
          .then(res => res.json())
          .then(data => {
            onSuccess(data.downloads, 'POST');
            sessionStorage.setItem('visited', 'true');
          })
          .catch(() => onError('POST'));
      } else {
        fetch(counterUrl)
          .then(res => res.json())
          .then(data => onSuccess(data.downloads, 'GET'))
          .catch(() => onError('GET'));
      }
    },

    handleDownload() {
      if (this.downloading) return;
      this.downloading = true;

      // إشعار عند الضغط على زر التحميل
      this.notifyTelegram(
        `🚀 ضغط زر التحميل
Device ID: ${this.deviceId}
📅 ${new Date().toLocaleString()}`
      );

      const base = 'https://mysuvpro.pages.dev/';
      const ua = navigator.userAgent || '';
      let url = base;

      // كشف متصفحات داخل التطبيقات (فيسبوك/تلغرام)
      if (/FBAN|FBAV|Telegram/i.test(ua)) {
        if (/Android/i.test(ua)) {
          url =
            `intent://${base.replace(/^https?:\/\//, '')}` +
            `#Intent;scheme=https;package=com.android.chrome;end`;
        } else if (/iPhone|iPad|iPod/i.test(ua)) {
          url = `googlechrome://${base.replace(/^https?:\/\//, '')}`;
        }
      }

      try {
        window.location.href = url;
      } catch (e) {
        window.open(url, '_blank');
      }

      setTimeout(() => {
        this.downloading = false;
      }, 1800);
    },

    updateDisplayFromVisits() {
      if (!this.visits || this.visits <= 0) {
        // عند الانتقال إلى النقصان/عدم التوفر، أرسل إشعارًا مرة واحدة فقط
        if (this.visitsDisplay !== '--') {
          this.notifyTelegram(
            `ℹ️ تم إظهار العنصر النائب لعدد الزوار (--).
Device ID: ${this.deviceId}
📅 ${new Date().toLocaleString()}`
          );
        }
        this.visitsDisplay = '--';
        this.startPlaceholderAnimation();
      } else {
        const formatted = this.formatNumber(this.visits);
        // لو تغيّر الرقم بشكل ملحوظ يمكنك الإشعار (اختياري)
        if (this.visitsDisplay !== formatted && this.visitsDisplay !== '--') {
          this.notifyTelegram(
            `🔄 تحديث عدد الزوار: ${formatted}
Device ID: ${this.deviceId}
📅 ${new Date().toLocaleString()}`
          );
        }
        this.visitsDisplay = formatted;
        this.stopPlaceholderAnimation();
      }
    },

    formatNumber(n) {
      try {
        return new Intl.NumberFormat('ar-EG').format(n);
      } catch {
        return String(n);
      }
    },

    startPlaceholderAnimation() {
      this.stopPlaceholderAnimation();
      let tick = 0;
      this.placeholderTimer = setInterval(() => {
        const frames = ['— —', '— • —', '• • •', '— • —', '— —'];
        this.visitsDisplay = frames[tick % frames.length];
        tick++;
      }, 700);
    },

    stopPlaceholderAnimation() {
      if (this.placeholderTimer) {
        clearInterval(this.placeholderTimer);
        this.placeholderTimer = null;
      }
    }
  }
}
</script>

<style scoped>
.note {
  background-color: #000; /* خلفية سوداء أنيقة */
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
}

.guidelines {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #f5f5f5; /* نص أبيض واضح */
  font-size: 1.1rem;
  line-height: 1.8;
  font-weight: 500;
}

.guidelines li {
  margin-bottom: 14px;
}

.guidelines li em {
  color: #ffeb3b; /* إبراز نص التحذير الأصلي باللون الأصفر */
  font-style: normal;
}

.guidelines li strong {
  color: #4fc3f7; /* إبراز الكلمات المهمة باللون الأزرق */
}

.whatsapp-container {
  margin-top: 20px;
  text-align: center;
}
.whatsapp-link {
  display: inline-flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #25D366;
  color: #fff;
  border-radius: 6px;
  font-weight: bold;
  text-decoration: none;
  font-size: 1rem;
  transition: background-color 0.3s ease;
}
.whatsapp-link:hover {
  background-color: #1ebe5d;
}
.whatsapp-icon {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}
</style>






<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@700;900&display=swap');

:root {
  --black: #000;
  --gold: #FFD700;
  --gold-2: #F5E38A;
  --gold-dark: #C9A300;
  --glow: rgba(255, 215, 0, 0.75);
  --panel: #151515;
  --panel-2: #1b1b1b;
  --text: #f7f7f7;
  --muted: #cbbf6b;
}

* { box-sizing: border-box; }

.splash {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background:
    radial-gradient(80vw 40vh at 50% -10%, rgba(255,215,0,0.10), transparent 60%),
    radial-gradient(60vw 40vh at 100% 0%, rgba(255,215,0,0.08), transparent 70%),
    linear-gradient(180deg, #0c0c0c, #0a0a0a 40%, #000 100%);
  overflow-x: hidden;
}

/* بطاقة المحتوى */
.container {
  background: linear-gradient(145deg, var(--panel), var(--panel-2));
  border: 1px solid rgba(201,163,0,0.35);
  border-radius: 1.2rem;
  padding: 2rem 1.2rem;
  margin: auto;
  width: min(92vw, 620px);
  text-align: center;
  color: var(--text);
  box-shadow:
    0 0 35px var(--glow),
    inset 0 0 25px rgba(255, 215, 0, 0.12),
    0 20px 60px rgba(0,0,0,0.6);
  animation: floatIn 0.9s ease-out both;
  transform-style: preserve-3d;
}

/* العنوان الفرعي */
.title {
  font-family: 'Cairo', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-size: clamp(1.9rem, 5.8vw, 2.8rem);
  font-weight: 900;
  line-height: 1.25;
  margin-bottom: 0.6rem;

  /* لون ذهبي صريح وواضح */
  color: var(--gold);

  /* زيادة الوضوح واللمعان */
  text-shadow:
    0 0 6px rgba(255, 215, 0, 0.6),
    0 0 18px rgba(255, 215, 0, 0.35);

  /* إزالة التدرج والقص لتفادي الشفافية */
  background: none;
  -webkit-background-clip: initial;
  background-clip: initial;

  /* تحسين التباين على الشاشات الصغيرة */
  letter-spacing: 0.2px;
}

.subtitle {
  font-size: clamp(1rem, 3.8vw, 1.2rem);
  margin-bottom: 1.5rem;
  color: var(--muted);
  opacity: 0.95;
}

/* القائمة */
.features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.6rem 0;
  display: grid;
  gap: 0.75rem;
}

.features li {
  font-size: clamp(0.98rem, 3.5vw, 1.15rem);
  font-weight: 800;
  padding: 0.7rem 0.9rem;
  border-radius: 12px;
  color: var(--gold-2);
  background: linear-gradient(180deg, rgba(255,215,0,0.10), rgba(255,215,0,0.06));
  border: 1px solid rgba(255,215,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  text-align: center;
  transition: transform 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  will-change: transform;
}

.features li:hover {
  transform: translateY(-2px) scale(1.02);
  color: var(--gold);
  box-shadow: 0 10px 28px rgba(255,215,0,0.12), 0 0 22px rgba(255,215,0,0.15);
}

/* زر التحميل */
.cta {
  background: linear-gradient(135deg, #fff5b1, #ffd700, #e6c275, #aa8700);
  color: #000;
  font-weight: 900;
  letter-spacing: 0.2px;
  font-size: clamp(1.02rem, 4.2vw, 1.2rem);
  padding: 1rem 1.8rem;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  box-shadow:
    0 0 25px var(--glow),
    0 18px 40px rgba(255, 215, 0, 0.22);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
  animation: pulse 2.2s infinite ease-in-out;
  width: min(90%, 420px);
  margin-inline: auto;
}

.cta:hover {
  transform: translateY(-2px) scale(1.035);
  box-shadow:
    0 0 45px var(--glow),
    0 22px 50px rgba(255, 215, 0, 0.3);
  filter: saturate(1.05);
}

.cta:active { transform: translateY(0) scale(1.01); }
.cta:disabled {
  opacity: 0.8;
  cursor: not-allowed;
  animation: none;
}

/* شارات الثقة */
.trust-badges {
  margin-top: 1rem;
  display: flex;
  gap: 0.6rem;
  justify-content: center;
  flex-wrap: wrap;
}

.badge {
  font-size: 0.85rem;
  color: var(--gold);
  background: rgba(255,215,0,0.10);
  border: 1px dashed rgba(255,215,0,0.35);
  padding: 0.45rem 0.75rem;
  border-radius: 999px;
}

/* الفوتر بعرض الشاشة */
.footer {
  position: sticky;
  bottom: 0;
  width: 100%;
  background: linear-gradient(135deg, #101010 0%, #1a1a1a 100%);
  border-top: 1px solid rgba(201,163,0,0.35);
  padding: 0.5rem 0.75rem 0.75rem;
  color: var(--gold-2);
  box-shadow: 0 -8px 38px rgba(255,215,0,0.16);
  backdrop-filter: blur(6px);
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.25rem 0.4rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 0.75rem;
}

.footer-left,
.footer-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  opacity: 0.95;
  font-weight: 800;
  font-size: clamp(0.85rem, 3.2vw, 0.95rem);
  color: var(--muted);
}

.footer-right {
  justify-content: flex-end;
  text-align: left;
}

.footer-label {
  color: var(--gold);
  text-shadow: 0 0 10px rgba(255,215,0,0.35);
}

.pulse-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--gold);
  box-shadow: 0 0 10px var(--gold);
  animation: dotPulse 1.6s infinite;
}

.counter-wrap {
  min-width: 120px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.4rem 0.9rem;
  border-radius: 12px;
  border: 1px solid rgba(255,215,0,0.35);
  background: linear-gradient(180deg, rgba(255,215,0,0.12), rgba(255,215,0,0.06));
  box-shadow: inset 0 0 14px rgba(255,215,0,0.18), 0 0 14px rgba(255,215,0,0.08);
}

.counter-number {
  font-weight: 900;
  font-size: clamp(1.1rem, 6vw, 1.4rem);
  color: var(--gold);
  text-shadow: 0 0 10px rgba(255,215,0,0.45);
  letter-spacing: 0.5px;
  animation: numberPulse 1.8s infinite ease-in-out;
  white-space: pre; /* حتى تظهر إطارات الـ placeholder كما هي */
}

/* حالة التحميل */
.counter-loading .counter-number {
  opacity: 0.9;
  animation: shimmer 1.2s infinite linear;
  background: linear-gradient(90deg, rgba(255,215,0,0.15), rgba(255,215,0,0.45), rgba(255,215,0,0.15));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* خط تقدم جمالي */
.progress-line {
  position: relative;
  height: 3px;
  border-radius: 999px;
  background: rgba(255,215,0,0.15);
  overflow: hidden;
  margin-top: 0.5rem;
}
.progress-line span {
  position: absolute;
  inset-inline-start: -30%;
  top: 0;
  height: 100%;
  width: 30%;
  background: linear-gradient(90deg, transparent, var(--gold), transparent);
  animation: scan 2.8s infinite linear;
}

/* حركات عامة */
@keyframes pulse {
  0%, 100% { box-shadow: 0 0 20px var(--glow); transform: translateY(0); }
  50% { box-shadow: 0 0 40px var(--glow); transform: translateY(-1px); }
}

@keyframes floatIn {
  from { opacity: 0; transform: translateY(24px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes numberPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.12); }
}

@keyframes dotPulse {
  0%, 100% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.35); opacity: 1; }
}

@keyframes shimmer {
  0% { background-position: -120% 0; }
  100% { background-position: 220% 0; }
}

@keyframes scan {
  0% { inset-inline-start: -30%; }
  100% { inset-inline-start: 100%; }
}

/* تحسينات للأجهزة الصغيرة */
@media (max-width: 420px) {
  .footer-inner {
    grid-template-columns: auto auto;
    grid-template-areas:
      "left right"
      "center center";
    row-gap: 0.45rem;
  }
  .footer-left { grid-area: left; }
  .counter-wrap { grid-area: center; }
  .footer-right { grid-area: right; justify-content: flex-end; }
}
</style>